import React, { memo } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControlLabel,
  Checkbox,
  Box,
  Typography,
} from '@mui/material';
import { format } from 'date-fns';

const statusOptions = [
  { value: 'on_time', label: 'On Time & In Zone' },
  { value: 'late', label: 'Late Clock-In' },
  { value: 'outOfZone', label: 'Out of Zone' },
  { value: 'missedOut', label: 'Missing Clock-Out' },
  { value: 'no_records', label: 'No Records' },
  { value: 'vacation', label: 'Vacation' },
];

function StatusFilterModal({
  open,
  date,
  onClose,
  selectedStatuses,
  setSelectedStatuses,
  resetFilters,
}) {
  const handleStatusChange = (status) => {
    setSelectedStatuses((prev) =>
      prev.includes(status)
        ? prev.filter((s) => s !== status)
        : [...prev, status]
    );
  };

  const handleReset = () => {
    setSelectedStatuses([]);
    resetFilters();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        Filter by Status for {date ? format(date, 'EEE d MMM yyyy') : ''}
      </DialogTitle>
      <DialogContent>
        <Box display="flex" flexDirection="column" gap={1}>
          {statusOptions.map((option) => (
            <FormControlLabel
              key={option.value}
              control={
                <Checkbox
                  checked={selectedStatuses.includes(option.value)}
                  onChange={() => handleStatusChange(option.value)}
                  size="small"
                />
              }
              label={<Typography variant="body2">{option.label}</Typography>}
            />
          ))}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleReset} color="secondary">
          Reset
        </Button>
        <Button onClick={onClose} variant="contained">
          Apply
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default memo(StatusFilterModal);